import React from 'react'
import Grid from '@material-ui/core/Grid';
import { Fade, IconButton, makeStyles, Typography } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import BannerImage from '../../Images/ReducedCRFBanner.png'
import logoImage from '../../Images/acuity-coaching-simple-logo2.svg'
import Mailto from './Mailto';
import { useLocation } from 'react-router-dom';
const useStyles = makeStyles((theme) => ({
    root: {
        // flexGrow: 1,
        scrollBehavior: 'hide'
    },
    bannerImg: {
        backgroundSize: 'cover',
        width: '100vw',
        // height: '257px'
    },
    checkcircle: {
        color: 'rgba(46, 177, 80)',
        fontSize: '50px'
        // width: 45
    },
    iconbutton: {
        color: 'rgba(46, 177, 80,0.2)',
        backgroundColor: 'rgba(46, 177, 80,0.2)'
    }

}))

export default function EvaluationAcknowledge() {
    const classes = useStyles();
    const location = useLocation()
    console.log(location)
    return (
        <div><Grid container spacing={4}>
            <Grid item xs={12}>
                <img src={BannerImage} alt='Evaluation' className={classes.bannerImg} />
            </Grid>
            <Grid item xs={12}></Grid>
            <Grid item xs={12}></Grid>
            <Grid item xs={12} style={{ textAlign: 'center' }}>
                <IconButton size='small' className={classes.iconbutton}><CheckCircleIcon className={classes.checkcircle} /></IconButton>
            </Grid>
            <Grid item xs={12}>
                <Typography variant='subtitle1' style={{ fontFamily: 'Open Sans', textAlign: 'center', paddingBottom: ' 13px' }}>Access to this form is restricted.

                </Typography>
                <Typography variant='subtitle1' style={{ fontFamily: 'Open Sans', textAlign: 'center' }} >If you have any questions please contact  {""}
                    <Mailto email="support@acuitycoaching.com" body="Please enter your query :">
                        support@acuitycoaching.com
                    </Mailto></Typography>
            </Grid>
            {/* <Grid item xs={12}>
                <Typography variant='h3' style={{ fontFamily: 'Open Sans', textAlign: 'center', fontWeight: 700, padding: ' 0px', marginTop: '50px' }}>Acuity Coaching</Typography>

            </Grid> */}
            <Grid item xs={12} style={{ textAlign: 'center', marginTop: 10 }}> <img src={logoImage} style={{ width: '150px', padding: "0px", marginTop: '-28px' }} alt="logo" /></Grid>
        </Grid>
        </div>
    )
}
